export const ADVANCE_INVOICE_SAMPLE = {
  clientName: 'Sarah Mitchell',
  quoteNumber: 'TR-1782460750614-961',
  itemCost: 1804,
  total: 1831.06,
  oneOff: false,
  checkoutUrl: 'https://app.trustjet.ai',
  services: [
    { item: 'Limousine service', amount: 484.00, tax: 44.00 },
    { item: 'In-house standard catering', amount: 1320.00, tax: 120.00 },
  ],
  taxPct: '10%',
  cardFee: 73.24,
  cardFeePct: '4%',
  paidBy: 'Sarah Mitchell',
  cardBrand: 'Visa',
  cardLast4: '3456',
};
